import React from "react";

const Copyright = () => {
  return (
    <div className="copyright">
      <p>© 2023 Salon / Institut de beauté de Julie Bengueddach</p>
    </div>
  );
};

export default Copyright;
